import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Loader } from 'src/components/common/Loader';
import { ForcedRankingDetails } from 'src/components/ForcedRankingDetails';
import { isAuthorizedQuery } from 'src/selectors/isAuthorizedQuery';
import { useQueryForcedRankingStrategy } from 'src/hooks/useQueryForcedRankingStrategy';
import { productVersionQueryKey } from 'src/hooks/useQueryProductVersion';
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEY as CONSOLIDATION_CONFIG_QUERY_KEY, queryConsolidationConfiguration } from 'src/queries/queryConsolidationConfiguration';
import { queryProductVersion } from 'src/queries/queryProductVersion';

const ForcedRankingDetailsPage = (): JSX.Element => {
    const { strategyName } = useParams();
    const accessToken = useRecoilValue(isAuthorizedQuery);
    const { data: strategy, isLoading } = useQueryForcedRankingStrategy(accessToken, strategyName ?? '');
    const queryClient = useQueryClient();

    // Prefetch product data and consolidation config when strategy loads
    useEffect(() => {
        if (strategy?.referenceProduct) {
            const productKey = strategy.referenceProduct;

            queryClient.prefetchQuery(
                productVersionQueryKey(accessToken, { productKey }),
                queryProductVersion,
                { staleTime: 5 * 60 * 1000 },
            );

            queryClient.prefetchQuery(
                [CONSOLIDATION_CONFIG_QUERY_KEY, accessToken, productKey],
                queryConsolidationConfiguration,
                { staleTime: 5 * 60 * 1000 },
            );
        }
    }, [strategy, accessToken, queryClient]);

    if (isLoading || !strategy) {
        return <Loader />;
    }

    return (
        <ForcedRankingDetails
            strategy={{
                ...strategy,
                cultureVariantRankings: strategy.cultureVariantRankings ?? [],
            }}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default ForcedRankingDetailsPage;
